import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { LettereDiffidaEsitoSpedizioneForm } from '../../../form/lettera-diffida-esito-spedizione-form';
import { SezioneLettereDiffidaResponse } from '../../../models/dto/sezione-lettere-diffida-response';

import { EsitoSpedizioneDiffida } from '../../../models/esito-spedizione-diffida';

@Component({
    selector: 'div [lettera-diffida-esito-spedizione-form-add]',
  templateUrl: '../../../form/lettera-diffida-esito-spedizione-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class LettereDiffidaEsitoSpedizioneAddComponent extends LettereDiffidaEsitoSpedizioneForm implements OnInit {
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  idSezioneLettereDiffida: string;
  idLetteraDiffida: string;
  updateUrl: string;

  constructor(@Inject(HelpersService) helpers: HelpersService, @Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm) {
        super(helpers, operationService, campiForm);
  }

  ngOnInit() {
    this.setTitle('Aggiungi esito spedizione');
    this.isInserimento(true);
  }

  inizializza(updateUrl: string, idLetteraDiffida: string, idSezioneLettereDiffida: string) {
    this.idLetteraDiffida = idLetteraDiffida;
    this.idSezioneLettereDiffida = idSezioneLettereDiffida;
    this.updateUrl = updateUrl;
    this.populateSelect();
    this.createForm();
  }

  getEsitoSpedizioneLetteraDiffida(): EsitoSpedizioneDiffida {
    return new EsitoSpedizioneDiffida();
  }

  getRequest(esitoSpedizione: EsitoSpedizioneDiffida) {
    this.operationsService.setEsitoSpedizioneToLetteraDiffida(this.updateUrl, this.idLetteraDiffida, this.idSezioneLettereDiffida, esitoSpedizione).subscribe(response => this.returnSetSezLettereDiffida(response));
  }

  returnSetSezLettereDiffida(response: SezioneLettereDiffidaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit();
    }
  }
}
